import { render, staticRenderFns } from "./EditarUsuario.vue?vue&type=template&id=2613de16&scoped=true"
import script from "./EditarUsuario.vue?vue&type=script&lang=ts"
export * from "./EditarUsuario.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2613de16",
  null
  
)

export default component.exports